export default "__VITE_ASSET__1M0PmNVQ__"